import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "@/components/Layout";
import Chat from "@/pages/Chat";
import Ops from "@/pages/Ops";
import Biz from "@/pages/Biz";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/chat" replace />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/ops" element={<Ops />} />
        <Route path="/biz" element={<Biz />} />
        <Route path="*" element={<Navigate to="/chat" replace />} />
      </Route>
    </Routes>
  );
}
